define([
	"dojo/_base/declare",
	"./_VectorNumber"
], function(declare,_VectorNumber) {

	return declare(_VectorNumber, {
		html1: '<span class="pattern">',
		cssBaseSize: " PatternBase"
	});
});